import { useGetOne, useTranslate } from "ra-core";
import { Skeleton } from "@/components/ui/skeleton";
import { formatCurrency } from "../shared/financeFormatters";
import type { AccountBalance } from "../../types";

interface Props {
  accountId: number | string;
}

export const AccountBalanceBadge = ({ accountId }: Props) => {
  const translate = useTranslate();
  const { data, isPending, error } = useGetOne<AccountBalance>(
    "account_balances",
    { id: accountId },
    { enabled: accountId != null },
  );

  if (isPending) return <Skeleton className="h-4 w-20" />;
  if (error || !data)
    return (
      <span className="text-muted-foreground text-sm">
        {translate("finance.balanceUnavailable", { _: "—" })}
      </span>
    );

  return (
    <span
      className={
        data.current_balance >= 0
          ? "font-semibold"
          : "font-semibold text-rose-600"
      }
    >
      {formatCurrency(data.current_balance, data.currency)}
    </span>
  );
};
